import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
/**
 * Confirmation dialog for the opponent — respond to a draw proposal
 * (accept | decline). Only the player who was proposed to can accept.
 */
export default class RespondDrawModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", false);
  }
  className() {
    return 'ArenaRespondDrawModal Modal--small';
  }
  title() {
    return m('[', null, m("i", {
      className: "fas fa-handshake"
    }), " ", app.translator.trans('forumaker-arena.forum.respond_draw.title'));
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m("p", {
      className: "ArenaRespondDrawModal-text"
    }, app.translator.trans('forumaker-arena.forum.respond_draw.text', {
      name: m("strong", null, this.attrs.proposerName)
    })), m("div", {
      className: "ArenaRespondDrawModal-actions"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      icon: "fas fa-handshake",
      loading: this.loading,
      onclick: () => this.respond(true)
    }, app.translator.trans('forumaker-arena.forum.respond_draw.accept_btn')), m(Button, {
      className: "Button Button--block",
      disabled: this.loading,
      onclick: () => this.respond(false)
    }, app.translator.trans('forumaker-arena.forum.respond_draw.decline_btn'))));
  }
  async respond(accept) {
    this.loading = true;
    m.redraw();
    try {
      var _this$attrs$onRespond, _this$attrs;
      await app.request({
        method: 'POST',
        url: "".concat(app.forum.attribute('apiUrl'), "/arena/battles/").concat(this.attrs.battle.id(), "/respond-draw"),
        body: {
          accept
        }
      });
      this.hide();
      (_this$attrs$onRespond = (_this$attrs = this.attrs).onResponded) == null || _this$attrs$onRespond.call(_this$attrs, accept);
    } catch (_unused) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('forumaker-arena.forum.respond_draw.error'));
      this.loading = false;
      m.redraw();
    }
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/RespondDrawModal', RespondDrawModal);